<template>
<div class="chapter">
<div class="inner_page">
<p class="center2"><span class="small">ACKNOWLEDGMENTS</span></p>
<p class="noindent">The "Mark Dalton: Owner Operator" stories would never have shifted into gear without the encouragement of former <em>Truck News</em> editor John G. Smith who invited me to write a story for the magazine in the summer of 1999; I'd also like to thank former <em>Truck News</em> editors John Curran and Ingrid Phanuef, <em>Truck News </em>executive editor James Menzies, and publisher Rob Wilkins for their continued and enthusiastic support; Also, many of the stories have benefited from the input from people working in the trucking industry. I am especially indebted to the following people for their help: Rob Quentin, former service manager at Brampton Peterbilt; 1996 <em>Truck News</em> Owner/Operator of the Year Dale Holman; dispatcher Marcel Larendeau of Bison Transport; and Dan Simcock of Arnold Brothers Transport.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?55a3cb67